import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import { DateFilterOperator } from "@redotech/redo-model/views/advanced-filters/date-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const SLADeliveryPromiseFilter: AdvancedTableFilter = {
  type: AdvancedFilterType.DATE,
  Icon: CalendarIcon,
  data: {
    name: "slaDeliveryPromise",
    type: AdvancedFilterType.DATE,
    value: null,
    operator: DateFilterOperator.AFTER,
  },
  displayName: "Fulfillment promise",
};
